import { createFileRoute } from "@tanstack/react-router";
import { ConsortiumPage } from "../../pages/consortium";

export const Route = createFileRoute("/_authed/consortium")({
  component: ConsortiumPage,
});
